export const smartLockerPackageConstants = {
  // GET_ALL: 取得所有智慧櫃包裹紀錄
  GET_ALL_REQUEST: "SMART_LOCKER_PACKAGE_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "SMART_LOCKER_PACKAGE_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "SMART_LOCKER_PACKAGE_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "SMART_LOCKER_PACKAGE_RESET_ALL_SUCCESS"
};
